const inputs = Object.freeze({
    NAME: 'Имя',
    AGE: 'Возраст',
    ROLE: 'Должность'
})

export default inputs